import Dispatcher from './Dispatcher';


import {ApplicationActionTypes} from './ActionTypes';
import {SessionActionTypes} from './ActionTypes';
import {ServerActionTypes} from './ActionTypes';



export const SessionActions = {


    createSession(session) {
        Dispatcher.dispatch({
            type: SessionActionTypes.CREATE_SESSION,
            session
        });
    },


    closeSession() {
        Dispatcher.dispatch({
            type: SessionActionTypes.CLOSE_SESSION,
        });
    },


};


/*
 *
 */
export const ApplicationActions = {

    clearSelectedOrder(orderId) {
        Dispatcher.dispatch({
            type: ApplicationActionTypes.CLEAR_ORDER_SELECTED,
            orderId
        });
    },

    updateSelectedOrder(order) {
        Dispatcher.dispatch({
            type: ApplicationActionTypes.UPDATE_ORDER_SELECTED,
            order
        });
    },


    updateHighlightedDriver(driver) {
        Dispatcher.dispatch({
            type: ApplicationActionTypes.UPDATE_DRIVER_HIGHLIGHTED,
            driver
        });
    },



    updateDriverFilters(filters) {
        Dispatcher.dispatch({
            type: ApplicationActionTypes.UPDATE_DRIVER_FILTERS,
            filters
        });
    },



    updateHighlightedSheduled(scheduled){
        Dispatcher.dispatch({
            type: ApplicationActionTypes.UPDATE_SCHEDULED_HIGHLIGHTED,
            scheduled
        });
    },

    onClickScheduledFastForward(scheduled){
        Dispatcher.dispatch({
            type: ApplicationActionTypes.ACTION_SCHEDULED_FASTFORWARD,
            scheduled
        });
    },


    onClickScheduledConfirmation(scheduled){
        Dispatcher.dispatch({
            type: ApplicationActionTypes.ACTION_SCHEDULED_CONFIRMATION,
            scheduled
        });
    },

};



/*
 *
 */
export const ServerActions = {


    updateServerData(data) {
        Dispatcher.dispatch({
            type: ServerActionTypes.UPDATE_SERVER_DATA,
            data
        });
    },

    updatedScheduledOrders(data, orders){
        Dispatcher.dispatch({
            type: ServerActionTypes.UPDATE_SCHEDULED_ORDERS,
            data,
            orders
        });
    },


    requestScheduledOrdersUpdate(data){
        Dispatcher.dispatch({
            type: ServerActionTypes.REQUEST_SCHEDULED_ORDERS_UPDATE,
            data
        });
    },


};


// WEBPACK FOOTER //
// ./src/data/Action.js